import ExperienceMarker from '../../../../components/Experience/ExperienceMarker';

// The experience pins the map draws: `TripMap` decides where a pin goes, the
// TO decides what its card is.
export default function useComposeMapMarkers({
  addExperience,
  getExperienceCompatibility,
}) {
  return {
    renderExperienceMarker: experience => (
      <ExperienceMarker
        experience={experience}
        mode="compose"
        isForTrip={true}
        onSelect={() => addExperience(experience?.id)}
        compatibility={getExperienceCompatibility(experience)}
      />
    ),
    renderItineraryExperienceMarker: (experience, { typeOverride }) => (
      <ExperienceMarker
        experience={experience}
        mode="itinerary"
        isForTrip={true}
        lat={experience?.startPosition?.lat}
        lng={experience?.startPosition?.lon}
        typeOverride={typeOverride}
      />
    ),
  };
}
